import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';

export const pendingInvoicesGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  if (route.queryParamMap.has('id')) return true;

  return router.createUrlTree(['/cotizador']);
};
